
const requestTypes = {
    question: "QUESTION",
    problem: "PROBLEM",
    suggestion: "SUGGESTION",
    request: "REQUEST",
    other: "OTHER"
}

export default requestTypes